__turbopack_context__.v({
  "link": "tweet-replies-module__DsB8nG__link",
  "replies": "tweet-replies-module__DsB8nG__replies",
  "text": "tweet-replies-module__DsB8nG__text",
});
